







































































import { Vue, Component, Prop } from "vue-property-decorator";
import { NoticeBar } from "vant";
import * as _ from "lodash";
import { TradeDetailEntity } from "@/model/Bill";
@Component({
  components: {
    [NoticeBar.name]: NoticeBar,
  },
})
export default class RetainTickets extends Vue {
  @Prop()
  value: TradeDetailEntity[] = [];
  @Prop({ default: true })
  isShowMore = true;

  @Prop()
  @Prop({ default: false })
  isEqualTrip = false;

  ToOrderDetail(OrderID: string) {
    let __self = this;
    __self.$router.push({
      path: "/order/details",
      query: {
        OrderID: OrderID,
      },
    });
  }

  @Prop({ default: true })
  isShowMoreFlag: boolean = true;

  MoreLowestLists() {
    let __self = this;
    __self.isShowMore = !__self.isShowMore;
  }
}
